/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');
const sorAddressForm = require('./sorAddressForm');
const sorCreditCard = require('./sorCreditCard');
const sorAddProductForm = require('./sorAddProductForm');
const sorProduct = require('./sorProduct');

const subscriptionViewOptions = {
  autoOpen: true,
  modal: true,
  dialogClass: 'smart-order-refill-modal',
  width: '43.75rem',
  title: typeof SmartOrderRefillSettings !== 'undefined' ? SmartOrderRefillSettings.Resources.SOR_DIALOG_SUBSCRIPTION : '',
  buttons: {
    SOR_GLOBAL_CLOSE: sorHelpers.sorModal.closeModal
  }
};

const initSubscriptionView = function () {
  $('.subscription.view').on('click', function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();
      $(this).spinner().start();
      const url = $(this).attr('data-link');
      const $container = sorHelpers.sorModal.createContainer('#subscriptionview');

      $container.load(url, function () {
        $(this).spinner().stop();
        sorHelpers.sorCharLimitation.limitCharacters();
        sorHelpers.sorModal.createModal($container, subscriptionViewOptions);
        sorProduct.refreshSorProductOosAlertsIn($container);
        sorAddressForm.initAddressChangeForm('#subscriptionview', url);
        sorCreditCard.initCreditCardView();
        sorAddProductForm.initAddProductForm();
        sorHelpers.sorMultiPack.initMultiPackEvents();
      });
    }
  });
};

module.exports = {
  initSubscriptionView: initSubscriptionView
};
